import { AfterContentInit, Component, Input, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/services/loader.service';
import { MatIcon } from '@angular/material/icon';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIcon, UpperCasePipe, TranslatePipe]
})
export class ErrorComponent implements OnDestroy {
    protected route = inject(ActivatedRoute);
    protected router = inject(Router);


    code: string;
    message: string;

    protected subscription: Subscription = new Subscription();

    constructor() {
        this.subscription.add(this.route.params.subscribe(async (params) => {
            if (params && params['code']) {
                //Retrieve Project ID
                this.code = params['code'];
            }
        }));
        this.subscription.add(this.route.queryParams.subscribe(async (params) => {
            if (params && params['message']) {
                //Retrieve Project ID
                this.message = params['message'];
            }
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}
